define('tableFieldView',[
    'module',
    'marionette',
    'underscore',
    'template!tableFieldView'
], function (
    Module,
    Marionette,
    _,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'table-field-view',

        initialize: function () {
            this.tableView = this.options.tableView;
            this.rowView = this.options.rowView;
            this.field = this.options.field;

            if(this.field.modelEvent)
                this.model.on(this.field.modelEvent, this.render, this);
        },

        /*modelEvents: {
          change: 'render'
        },*/

        onBeforeRender: function() {
            if(this.field && this.field.className)
                this.$el.addClass(this.field.className);
        },

        onRender: function() {
            try {
                if(this.field.onRender) {
                    this.field.onRender(this);
                } else {
                    if(this.field.bind) {
                        var value = this.model.get(this.field.bind);

                        if(value !== undefined && value !== null) {
                            // Use formatter if provided, otherwise use raw value
                            var displayValue = value;
                            if(this.field.formatter && typeof this.field.formatter === 'function') {
                                displayValue = this.field.formatter(value, this.model);
                            }

                            this.$el.html(displayValue);
                            this.$el.attr('title', displayValue);
                        }
                    }
                }
            } catch(e) {
                console.log('row field view error: ', e);
            }
        }
    });
});
